import React, { useEffect, useRef, useState } from 'react';
import playImg from 'assets/play.svg';
import styled from 'styled-components';
import { isBlank } from 'utils/storeUtils';

export default function VideoPlayer(props) {
  const {
    size = 420,
    imageUrl,
    videoUrl,
    setVideoModalState,
    onImageLoad,
    isNsfw = false,
  } = props;

  const [isPlaying, setIsPlaying] = useState(false);
  const [pause, setPause] = useState(false);
  const xUrl = imageUrl || props.url;

  const videoRef = useRef();

  useEffect(() => {
    if (videoRef.current) {
      if (pause === false) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  }, [pause]);

  if (isBlank(videoUrl)) {
    return null;
  }

  const handlePlay = () => {
    if (isNsfw) {
      setIsPlaying(false);
    } else {
      setPause(!pause);
    }
  };

  const handlePhotoClick = () => {
    if (isNsfw) {
      return;
    }

    if (setVideoModalState) {
      setVideoModalState({ isOpen: true, videoUrl, pictureUrl: xUrl });
    } else {
      setIsPlaying(true);
    }
  };

  const handleImageLoad = (e) => {
    if (onImageLoad) {
      onImageLoad(e);
    }
  };

  return (
    <Wrapper style={{ width: size, height: size }}>
      <InnerPlaceholder style={{ width: size, height: size }}>
        {!isPlaying && (
          <Photo
            src={xUrl}
            onClick={handlePhotoClick}
          >
            {!isNsfw && <PlayImage alt={'play'} src={playImg} />}
          </Photo>
        )}

        {isPlaying && (
          <Video
            ref={videoRef}
            autoPlay={isPlaying}
            visible={isPlaying}
            onClick={handlePlay}
            onEnded={() => setIsPlaying(false)}

          >
            <source src={videoUrl} type="video/mp4" />
          </Video>
        )}
      </InnerPlaceholder>

      {onImageLoad && xUrl && (
        <HiddenImage
          src={xUrl}
          onLoad={handleImageLoad}
          onError={handleImageLoad}
        />
      )}
    </Wrapper>
  );
}

const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  box-sizing: border-box;
  border-radius: 12px;
  cursor: pointer;
`;

const Wrapper = styled.div`
  padding: 5px;
  border-radius: 12px;
`;

const Photo = styled.div`
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-image: url("${props => props.src}");
  border-radius: 12px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const PlayImage = styled.img`
  height: 90px;
  opacity: 0.9;

  :hover {
    opacity: 1;
  }

  @media (max-width: 400px) {
    height: 50px;
  }
`;

const InnerPlaceholder = styled.div`
  background: black;
  border-radius: 12px;
`;

const HiddenImage = styled.img`
  position: absolute;
  visibility: hidden;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
`;
